import React from "react"

export default function ProseWrapper({ children }) {
  return <div className="mt-8 prose prose-lg">{children}</div>
}
